import { TabsDesignTokens } from "@primeuix/themes/types/tabs";
import { primitiveColorTokens } from "src/assets/layout/styles/tokens/primitive";

export const tabs: TabsDesignTokens = {
    colorScheme: {
        light: {
            tab: {
                background: primitiveColorTokens.white[375],
                color: primitiveColorTokens.grey[800],
                activeBackground: primitiveColorTokens.blue[450],
                activeColor: primitiveColorTokens.white[100],
                hoverBackground: primitiveColorTokens.white[375],
                padding: "0.5rem 1.125rem",
            },
        },
    },
    tablist: {
        borderWidth: "0px",
    },
    tabpanel: {
        padding: "2.5px 0px",
    },
    activeBar: {
        background: "transparent",
    },
    css: () => {
        /**
         * Base Overrides for p-tabs
         */
        const base = `
            .p-tablist {
                border-radius: var(--p-azara-layout-border-radius);
                font-family: var(--font-family-sans) !important;
            }

            .p-tab {
                flex-grow: 1;
                display: flex;
                justify-content: center;
            }
        `;

        return base;
    },
};
